import React, { useContext } from 'react';
import { CarouselContext } from './CarouselContext';
import { Button, colors } from '@soluto-private/mx-asurion-ui-react';
import styled, { css } from 'styled-components';
const handleClick = (direction, ref, jump) => {
  const distance = jump * (direction === 'left' ? -1 : 1);
  ref.current.scrollBy({
    left: distance
  });
};
const StyledButton = styled(Button).withConfig({
  displayName: "StyledButton",
  componentId: "asurion-ui-react__sc-ijdimd-0"
})(["opacity:", ";transition:opacity 0.25s ease-in-out;border-width:0;&:focus-visible{opacity:1;}", ""], ({
  $isVisible
}) => $isVisible ? 1 : 0, ({
  $hidden
}) => $hidden && css(["&[aria-disabled='true']{background:", ";border-color:", ";color:", ";cursor:not-allowed;opacity:0;&:focus-visible{opacity:1;}}"], colors.disabledBackground, colors.disabledBackground, colors.disabledText));
export const ControlButton = ({
  direction,
  $isVisible,
  visibility
}) => {
  const {
    carouselContainer,
    elementWidth,
    carouselWidthPx,
    variant
  } = useContext(CarouselContext);
  let scrollJump;
  if (variant === 'page' || variant === 'slide') {
    scrollJump = carouselWidthPx / 2 + 16;
  } else {
    scrollJump = parseInt(elementWidth, 10) * 16;
  }
  return /*#__PURE__*/React.createElement(StyledButton, {
    onClick: () => handleClick(direction, carouselContainer, scrollJump),
    iconSrc: `arrow-${direction}`,
    color: "secondary",
    size: "small",
    "aria-label": `${direction}-carousel-button`,
    "aria-disabled": visibility !== 'visible',
    $hidden: visibility === 'hidden',
    $isVisible: $isVisible
  });
};